"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const expressions_1 = require("@mwater/expressions");
const RemovableComponent_1 = __importDefault(require("./RemovableComponent"));
const ExprComponent_1 = __importDefault(require("./ExprComponent"));
const contexts_1 = require("./contexts");
// Build enumset
function BuildEnumsetExprComponent(props) {
    const locale = (0, react_1.useContext)(contexts_1.LocaleContext);
    const handleValueChange = (id, value) => {
        const values = { ...props.value.values, [id]: value };
        props.onChange({ ...props.value, values });
    };
    const renderValues = () => {
        const exprUtils = new expressions_1.ExprUtils(props.schema);
        return (react_1.default.createElement("table", { className: "table table-bordered" },
            react_1.default.createElement("thead", null,
                react_1.default.createElement("tr", null,
                    react_1.default.createElement("th", { key: "name" }, T `Choice`),
                    react_1.default.createElement("th", { key: "include" }, T `Include if`))),
            react_1.default.createElement("tbody", null, props.enumValues.map((enumValue) => (react_1.default.createElement("tr", { key: enumValue.id },
                react_1.default.createElement("td", { key: "name" }, exprUtils.localizeString(enumValue.name, locale)),
                react_1.default.createElement("td", { key: "value", style: { maxWidth: "30em" } },
                    react_1.default.createElement(ExprComponent_1.default, { schema: props.schema, dataSource: props.dataSource, table: props.value.table, value: props.value.values[enumValue.id], onChange: (value) => handleValueChange(enumValue.id, value), types: ["boolean"] }))))))));
    };
    return (react_1.default.createElement(RemovableComponent_1.default, { onRemove: () => props.onChange(null) }, props.enumValues ? renderValues() : react_1.default.createElement("i", null, T `Cannot display build enumset without known values`)));
}
exports.default = BuildEnumsetExprComponent;
